import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer data-testid="footer" className="text-cream">
            <div className="relative">
                <img
                    src="/family-sunset.png"
                    alt="Silhouette of a family holding hands at sunset"
                    data-testid="family-scene"
                    className="block h-64 w-full object-cover object-[center_20%] sm:h-80 md:h-[420px]"
                />
                <div className="pointer-events-none absolute inset-x-0 bottom-0 h-28 bg-gradient-to-b from-transparent to-navy" aria-hidden="true" />
            </div>
            <div className="bg-navy py-14">
            <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-6 md:flex-row lg:px-10">
                <div>
                    <div className="flex justify-center md:justify-start">
                        <span className="inline-flex rounded-2xl bg-cream px-5 py-3">
                            <img src="/logo.png" alt="Ago GenApp" className="h-10 w-auto" />
                        </span>
                    </div>
                    <p className="mt-3 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-cream/50 md:text-left">
                        Today’s moments. Tomorrow’s memories.
                    </p>
                    <p className="mt-3 text-center text-sm text-cream/70 md:text-left">© 2026 Ago GenApp · agogenapp.com</p>
                </div>
                <p className="max-w-sm text-center font-mono text-[11px] uppercase tracking-[0.25em] text-cream/60 md:text-left">
                    A place for every memory. A gift for every child.
                </p>
                <nav className="flex items-center gap-8">
                    <Link data-testid="footer-privacy-link" to="/privacy" className="text-sm font-medium text-cream/85 transition-colors duration-300 hover:text-cream">
                        Privacy Policy
                    </Link>
                    <Link data-testid="footer-terms-link" to="/terms" className="text-sm font-medium text-cream/85 transition-colors duration-300 hover:text-cream">
                        Terms of Service
                    </Link>
                    <Link data-testid="footer-investors-link" to="/investors" className="text-sm font-medium text-cream/85 transition-colors duration-300 hover:text-cream">
                        Investors
                    </Link>
                </nav>
            </div>
            </div>
        </footer>
    );
}
